module.exports = __webpack_public_path__ + "static/media/cancel-icon.64b686a4.svg";